import { getLinks } from "../../links/api/api";
import { getUsers } from "../../users/utils/api";
import { api, getBanks, getCategories, getProjects } from "@";
import { mapSelectsOptions, searchValuesPayload } from "./helpers";

// Fetch affiliate donors based on search criteria
export const getAffiliateDonors = (page = 1, pageSize = "", search) => {
  return api.post(
    `/api/AdminAffiliateLink/affiliate-orders`,
    searchValuesPayload(page, pageSize, search),
  );
};

// Fetch banks, links, users, categories, and projects data
export const getBanksLinksUsersCategoriesProjects = async () => {
  try {
    const [
      banksResponse,
      linksResponse,
      usersResponse,
      categoriesResponse,
      projectsResponse,
    ] = await Promise.all([
      getBanks(),
      getLinks(),
      getUsers(),
      getCategories(),
      getProjects(1, null, null),
    ]);

    return {
      banks: mapSelectsOptions(banksResponse?.data?.data),
      users: mapSelectsOptions(usersResponse?.data?.data),
      categories: mapSelectsOptions(categoriesResponse?.data),
      links: mapSelectsOptions(linksResponse?.data?.data, "title"),
      projects: mapSelectsOptions(projectsResponse?.data?.data, "title"),
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

// Fetch bank accounts based on bank ID
export const getBankAccounts = (id) =>
  api.get(`/api/AdminBank/bank-accounts/${id}`);
